module.exports = __webpack_public_path__ + "static/media/con_cart.2ccd2186.png";